import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { environment } from "environments/environment";
import { map } from "rxjs/operators";
import { RoleForm } from "app/interfaces/role-form.interface";

const rolesUrlApi = environment.rolesUrlApi;
const rolesListUrlApi = environment.rolesListUrlApi;
const rolessAssignPermissionsUrlApi = environment.rolessAssignPermissionsUrlApi;
const rolesAssignViewPermissionUrlApi =
  environment.rolesAssignViewPermissionUrlApi;
const rolesByUserUrlApi = environment.rolesByUserUrlApi;

@Injectable()
export class RoleService {
  public user: RoleForm;

  constructor(private http: HttpClient) {}

  getRoles() {
    return this.http
      .request("GET", `${rolesListUrlApi}`, { responseType: "json" })
      .pipe(map((resp: any) => resp));
  }

  getRoleById(id: number) {
    return this.http
      .request("GET", `${rolesUrlApi}/` + id, { responseType: "json" })
      .pipe(map((resp: any) => resp));
  }
  getRoleByUser(id: number) {
    return this.http
      .request("GET", `${rolesByUserUrlApi}/` + id, { responseType: "json" })
      .pipe(map((resp: any) => resp));
  }

  updateRoleById(id: number, clientModel: RoleForm) {
    clientModel.tier = 1;
    const body = clientModel;
    return this.http
      .request("PUT", `${rolesUrlApi}/` + id, { body })
      .pipe(map((resp: any) => resp));
  }

  createRole(clientModel: RoleForm) {
    clientModel.tier = 1;
    const body = clientModel;
    return this.http
      .request("POST", `${rolesUrlApi}`, { body })
      .pipe(map((resp: any) => resp));
  }

  assignPermissions(idRole: number, arrayRolesSelected) {
    const body = { id_permissions: arrayRolesSelected };
    return this.http
      .request("PUT", `${rolessAssignPermissionsUrlApi}/` + idRole, { body })
      .pipe(map((resp: any) => resp));
  }

  assignViewPermissions(idRole: number, arrayRolesSelected) {
    const body = { views: arrayRolesSelected };
    return this.http
      .request("PUT", `${rolesAssignViewPermissionUrlApi}/` + idRole, { body })
      .pipe(map((resp: any) => resp));
  }

  deleteRoleById(id: number) {
    return this.http
      .request("DELETE", `${rolesUrlApi}/` + id, { responseType: "json" })
      .pipe(map((resp: any) => resp));
  }
}
